import React from "react";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";

import "../styles/languageBar.sass";

interface ILanguageBarFooterProps {
    onClick: () => void;
    disabled: boolean;
}

const LanguageBarFooter: React.FC<ILanguageBarFooterProps> = ({ 
    onClick, 
    disabled 
}) => (
    <>
        <Divider />
        <Button
            variant="text"
            color="primary"
            className="language-bar-footer-button"
            id="language-bar-add-all-translations-btn"
            onClick={onClick}
            disabled={disabled}
        >
            Add All Translations
        </Button>
    </>
);

export default LanguageBarFooter;